/**
 * SmsAnalyticsWidget — tiny dashboard tile. 4 numbers, one CTA.
 * Deliberately understated so it fits alongside the money tiles
 * without stealing focus.
 */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, ArrowRight, Loader2 } from 'lucide-react';
import api from '../lib/api';

export default function SmsAnalyticsWidget() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get('/messages/analytics')
      .then(r => setData(r.data))
      .catch(() => setData({ sent_30d: 0, received_30d: 0, opt_outs: 0, est_cost_30d: 0, unread: 0 }))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="rounded-2xl border border-white/[0.06] bg-white/[0.02] p-4 flex items-center justify-center h-32">
        <Loader2 className="animate-spin text-slate-500" size={16} />
      </div>
    );
  }
  const stat = (label, value) => (
    <div>
      <p className="text-[10px] uppercase tracking-wider font-bold text-slate-500">{label}</p>
      <p className="text-[18px] font-extrabold text-white tabular-nums mt-0.5" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>{value}</p>
    </div>
  );
  return (
    <Link
      to="/messages"
      data-testid="sms-widget"
      className="block rounded-2xl border border-white/[0.06] bg-white/[0.02] hover:bg-white/[0.04] hover:border-white/[0.12] transition-all p-4"
    >
      <div className="flex items-center justify-between mb-3">
        <div className="inline-flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-[#CBA33B]/12 flex items-center justify-center">
            <MessageSquare size={13} className="text-[#CBA33B]" />
          </div>
          <p className="text-[11px] uppercase tracking-[0.15em] font-bold text-slate-400">SMS — 30 days</p>
        </div>
        <div className="flex items-center gap-1.5 text-[11px] font-semibold text-[#CBA33B]">
          {data.unread > 0 && (
            <span className="px-1.5 py-0.5 rounded-full bg-rose-500 text-white text-[9.5px] font-bold">
              {data.unread} unread
            </span>
          )}
          Open <ArrowRight size={11} />
        </div>
      </div>
      <div className="grid grid-cols-4 gap-3">
        {stat('Sent', data.sent_30d)}
        {stat('Received', data.received_30d)}
        {stat('Opt-outs', data.opt_outs)}
        {stat('Est. cost', `$${data.est_cost_30d.toFixed(2)}`)}
      </div>
    </Link>
  );
}
